import { useEffect, useState } from 'react';

export const useFocus = (
  ref: React.RefObject<HTMLInputElement | null>,
  defaultState = false
) => {
  const [state, setState] = useState(defaultState);

  useEffect(() => {
    const updateFocusState = () => {
      setState(document.activeElement === ref.current);
    };

    document.addEventListener('focusin', updateFocusState);
    document.addEventListener('focusout', updateFocusState);

    // Keep initial state in sync for pre-focused/programmatically focused inputs.
    updateFocusState();

    return () => {
      document.removeEventListener('focusin', updateFocusState);
      document.removeEventListener('focusout', updateFocusState);
    };
  }, [ref]);

  return state;
};
